import React, { useContext, useState } from 'react';
import Loading from '../../Loading/Loading';
import Button from '../../Button';
import { ArrowNarrowRightIcon, ProgressHoldIcon } from '../../SVGIcons/SVGIcons';
import { dateConverter, parseProcessingStatus } from '../../../helpers';
import { useNavigate } from 'react-router';
import EmptyState from '../../EmptyState/EmptyState';
import useWindowSize from '../../../hooks/useWindowSize';

export default function CustomerListItems(props) {
	const { listItems, loading } = props || {};
	const [lastMousePress, setLastMousePress] = useState(null);
	const [newMousePress, setNewMousePress] = useState(null);

	let navigate = useNavigate();

	const { width } = useWindowSize();

	function onTouchStart(e) {
		setLastMousePress({ x: e.touches[0].clientX, y: e.touches[0].clientY });
		setNewMousePress({ x: e.touches[0].clientX, y: e.touches[0].clientY });
	}

	function onTouchMove(e) {
		setNewMousePress({ x: e.touches[0].clientX, y: e.touches[0].clientY });
	}

	function onTouchEnd(e, item) {
		if (newMousePress?.x === lastMousePress?.x && newMousePress?.y === lastMousePress?.y) {
			navigate(`/manage/customers/${item.customerUuid}`);
		}
	}

	function getLatestObjectEntry(object) {
		let latestEntry = null;
		let latestDate = new Date(0);

		for (const key in object) {
			const entry = object[key];
			const entryDate = new Date(entry.lastUsed);

			if (entryDate > latestDate) {
				latestDate = entryDate;
				latestEntry = entry;
			}
		}

		if (!latestEntry) {
			latestEntry = Object.values(object)[0];
		}

		return latestEntry;
	}

	return (
		<div className='listOuterCont'>
			<div className='list'>
				<div className='listHeader'>
					<h4>Name</h4>
					<h4>Last team</h4>
					<h4>Last ordered at</h4>
					<h4>Last behalf of</h4>
					<h4>Orders</h4>
					{width > 1028 && (
						<h4>
							<div style={{ visibility: 'hidden' }}>
								<Button
									text='See details'
									size='md'
									style='tertiary-secondary'
									iconRight={<ArrowNarrowRightIcon />}
								/>
							</div>
						</h4>
					)}
				</div>
				{!loading ? (
					<>
						{listItems && listItems?.length !== 0 ? (
							listItems.map((item, key) => {
								return (
									<div
										key={key}
										className='item'
										onTouchStart={onTouchStart}
										onTouchMove={onTouchMove}
										onTouchEnd={(e) => onTouchEnd(e, item)}>
										<p className='data'>{item.name}</p>
										<p className='data'>
											{item.customerTeams && Object.keys(item.customerTeams)?.length !== 0 ? (
												<>{getLatestObjectEntry(item.customerTeams)?.teamName || item.name}</>
											) : (
												<></>
											)}
										</p>
										<p className='data'>{dateConverter(item.updatedAt)}</p>

										<p className='data'>
											{item.customerOnBehalfOfUsers &&
											Object.keys(item.customerOnBehalfOfUsers)?.length !== 0
												? getLatestObjectEntry(item.customerOnBehalfOfUsers)?.name
												: ''}
										</p>
										<p className='data'>{item.ordersPlaced}</p>
										{width > 1028 && (
											<p className='data'>
												<Button
													text='See details'
													size='md'
													style='tertiary-secondary'
													iconRight={<ArrowNarrowRightIcon />}
													onClick={() => {
														navigate(`/manage/customers/${item.customerUuid}`);
													}}
												/>
											</p>
										)}
									</div>
								);
							})
						) : (
							<EmptyState body='No customers matched your search filters' header='No customers found' />
						)}
					</>
				) : (
					<Loading type='circle' />
				)}
			</div>
		</div>
	);
}
